module.exports = __webpack_public_path__ + "img/img-7.64c79e86.png";